import WebSocket from 'ws';

let originalRawMode: boolean | undefined;
let isRawModeSet = false;

export function enterInteractiveMode(
  socket: WebSocket,
  onResize?: () => void,
): NodeJS.Timeout {
  if (process.stdin.setRawMode) {
    originalRawMode = process.stdin.isRaw;
    process.stdin.setRawMode(true);
    isRawModeSet = true;
  }
  process.stdin.resume();

  process.stdin.on('data', (data) => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(data);
    }
  });

  const resizeHandler = () => {
    if (onResize) {
      onResize();
    }
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'resize',
          cols: process.stdout.columns,
          rows: process.stdout.rows,
        }),
      );
    }
  };

  process.stdout.on('resize', resizeHandler);

  const pingInterval = setInterval(() => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'ping',
          timestamp: Date.now(),
        }),
      );
    }
  }, 30 * 1000);

  const sigintHandler = () => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'close',
          reason: 'user_exit',
        }),
      );
      socket.close();
    }
  };

  process.on('SIGINT', sigintHandler);

  return pingInterval;
}

export function restoreTerminal(): void {
  if (process.stdin.setRawMode && isRawModeSet) {
    process.stdin.setRawMode(originalRawMode || false);
    isRawModeSet = false;
  }
  process.stdin.pause();

  process.stdin.removeAllListeners('data');
  process.stdout.removeAllListeners('resize');
  process.removeAllListeners('SIGINT');
}
